import React from 'react';
import './Button.css';

const Button = ({
  children,
  type = 'primary',
  size = 'medium',
  htmlType,
  onClick,
  disabled = false,
  className = '',
  enhanced = true,
  ...props
}) => {
  const buttonClass = `btn btn-${type} btn-${size} ${enhanced ? 'btn-enhanced ripple' : ''} ${className}`;

  return (
    <button
      type={htmlType || 'button'}
      className={buttonClass}
      onClick={onClick}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
